// extracted by mini-css-extract-plugin
export default {"password-reset-container":"PasswordReset_password-reset-container_Jmj4uWRzxUZuMwrvUv9m","password-reset-form":"PasswordReset_password-reset-form_ZUp5105_igD5fIxMyE7e"};